module.exports = __webpack_public_path__ + "static/media/markDown.d2a63eba.png";